<template>
  <div
    class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
  >
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <button
        class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
        type="button"
        @click="addShow = true"
        :key="index"
      >
        <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
        <span class="p-l-20 p-r-10">Add Note</span>
      </button>
    </div>
  </div>
  <dataTable
    :name="'CustomerNotes'"
    ref="agGrid"
    :columnDefs="columnDefs"
    :data="data"
    :addContextMenuItem="getContextMenuItems"
    @cellClicked="updateShow = $event.data"
  ></dataTable>
  <upsert
    v-if="addShow || updateShow != null"
    :CustomerId="setModel.Id"
    @add="$refs.agGrid.addRow([$event])"
    @update="$refs.agGrid.changeRow('Id', $event)"
    :setModel="updateShow"
    @close="
      addShow = false;
      updateShow = null;
    "
  ></upsert>
  <errorList
    v-if="scanErrorsPop != null"
    :CustomerProviderId="scanErrorsPop"
    @close="scanErrorsPop = null"
  ></errorList>
</template>

<script>
import upsert from "./upsert";
import errorList from "./errorList";
import moment from "moment";
export default {
  name: "Providers",
  components: { upsert, errorList },
  props: {
    setModel: Object,
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "UserId",
          width: 100,
          filter: "agNumberColumnFilter",
          field: "UserId",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Username",
          width: 180,
          filter: "agTextColumnFilter",
          field: "Username",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Note",
          filter: "agTextColumnFilter",
          field: "Note",
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Date",
          width: 140,
          filter: "agTextColumnFilter",
          field: "Date",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            return moment(new Date(params.value)).format("DD.MM.YYYY HH:mm");
          },
        },
      ],
      data: null,
      addShow: false,
      updateShow: null,
      scanErrorsPop: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`CustomerNotes/` + this.setModel.Id)
      .then((response) => {
        this.data = response.data;
      });
  },
  methods: {
    scan(item) {
      console.log("item", item);
      this.$appAxiosKolayrez
        .post(`Timer/Scan`, {
          CustomerId: null,
          ProviderId: null,
          CustomerProviderId: item.Id,
        })
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: response.data,
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text: "Are you sure you want to delete the customer note?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`CustomerNotes/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer note has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updateShow = params.node.data;
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>
